import { message } from "antd";
import { CLSTesting } from "util/setLocalStorageTesting";

export const enterOtherTesting = (user, props, data) => {
  CLSTesting();
  if (props?.props) {
    try {
      let setState = {
        data: data,
        groupId: props?.props?.location?.state?.detail?.id,
        time: data?.testingDuration?.endTimestamp * 1000,
        typeExam: "generalExam",
      };
      return (
        props?.props?.history.push({
          pathname: `/testing/${data.id}`,
          state: setState,
        }) ||
        props?.props?.props?.history?.push({
          pathname: `/testing/${data.id}`,
          state: setState,
        })
      );
    } catch (error) {
      message.error("เกิดข้อผิดพลาดก่อนเข้าทำข้อสอบ", [3]);
      return props.props.history.goBack() || props.props.props.history.goBack();
    }
  } else if (!props && data) {
    try {
      let setState = {
        data: data,
        typeExam: "generalExam",
      };
      return props?.props?.history.push({
        pathname: `/testing/${data.id}`,
        state: setState,
      });
    } catch (error) {
      return props.props.history.goBack() || props.props.props.history.goBack();
    }
  }
};
